import React, { useState, useEffect } from "react";
import {
  Share2,
  Bookmark,
  UserRound,
} from "lucide-react";
import RedButton from "../RedButton";
import { Link, Navigate } from "react-router-dom";
import companyDefault from "../../assets/img/dummyimage.png";


const CompaniesViewCard = ({item}) => {

    const [isLoggedIn, setIsLoggedIn] = useState(false);
          
    useEffect(() => {
      const token = localStorage.getItem("token");
      if (token) {
        setIsLoggedIn(true);
      }
    }, []);

    return (
        <>
        <div className="sr-result-card">
            <div className="row g-3 align-items-start">
                <div className="col-12 col-sm-auto">
                <div className="sr-company-icon">
                    <img
                    src={item.company_logo_url || item.image || companyDefault}
                    alt={item.company_name || item.name}
                    style={{ width: "50px", height: "50px", objectFit: "contain" }}
                    onError={(e) => { e.target.src = companyDefault; }}
                    />
                </div>
                </div>

                <div className="col-12 col-sm">
                <h2 className="sr-result-title">{item.company_name || item.name}</h2>
                <p className="sr-result-copy mt-1">{item.company_type || item.industry || "Company"}</p>                    
                </div>

                
                <div className="col-12 mt-16"> 
                <div className="row g-2">                   
                    <div className="col-12 col-sm-6">
                    <div className="bggraycol2 px-4 py-3 rounded-4 h-100">                        
                        <div className="text-uppercase ft-11 graytext">
                        INDUSTRY
                        </div>

                        <div className="fw-bold ft-14" style={{ color: "#2c2e33" }}>
                        {item.industry || "N/A"}
                        </div>
                    </div>
                    </div>

                    <div className="col-12 col-sm-6">
                    <div className="bggraycol2 px-4 py-3 rounded-4 h-100">                        
                        <div className="text-uppercase ft-11 graytext">
                        Headquarters
                        </div>

                        <div className="fw-semibold ft-14" style={{ color: "#2c2e33" }}>
                        {item.city_name && item.country_name 
                          ? `${item.city_name}, ${item.country_name}` 
                          : item.country_name || item.city_name || "N/A"}
                        </div>
                    </div>
                    </div>
                </div>               
                </div>



                <div className="col-12 mt-16">

                    {isLoggedIn ? (

                        <div className="d-flex align-items-center justify-content-between">

                            <div className="d-flex gap-2 items-center">
                            
                                <Link to="/"
                                    className="btn border-0 rounded-3 d-flex align-items-center justify-content-center"
                                    style={{
                                    width: "40px",
                                    height: "40px",
                                    background: "#FFF4F4",
                                    }}
                                >
                                    <Share2 size={18} color="#2F343B" />
                                </Link>

                                <Link to="/"
                                    className="btn border-0 rounded-3 d-flex align-items-center justify-content-center"
                                    style={{
                                    width: "40px",
                                    height: "40px",
                                    background: "#FFF4F4",
                                    }}
                                >
                                    <Bookmark size={18} color="#2F343B" />
                                </Link>
                            </div>

                            <RedButton
                                btntext="View Company Profile"
                                name="viewCompanyProfile"
                                // onClick={() => Navigate ("/company-profile")}
                            />

                        </div>

                        ) : (

                        <div className="d-flex align-items-center justify-content-between p-3 rounded-3"
                            style={{
                                background: "#FFF1F1",
                                border: "1px solid #F5D6D6",
                            }}
                            >
                            <div className="d-flex align-items-center gap-2">
                                <UserRound size={14} color="#6B7280" />

                                <span
                                className="fw-semibold"
                                style={{
                                    color: "#6B7280",
                                    fontSize: "13px",
                                }}
                                >
                                Sign Up To Unlock Full Details, Eligibility And Insights.
                                </span>
                            </div>

                            

                            <RedButton
                                btntext="Unlock Full Details"
                                name="unlockFullDetails"
                                // onClick={() => Navigate ("/company-profile")}
                            />



                        </div>
                            
                        )
                    }    

                </div>


            </div>
            </div>
        </>
    );
};

export default CompaniesViewCard;

